<template>
  <div class="w-auto md:w-48">
    <div class="relative">
      <div class="absolute top-0 right-0 p-2 md:p-6" v-if="this.activeProduct === this.productName">
        <svg class="w-6 h-6" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g fill-rule="nonzero">
              <path
                d="M31.1442786,171.840796 C5.2779518,146.858262 -5.09578082,109.862896 4.01023318,75.0738981 C13.1162472,40.2848999 40.2848999,13.1162472 75.0738981,4.01023318 C109.862896,-5.09578082 146.858262,5.2779518 171.840796,31.1442786 C209.549474,70.1869539 209.010186,132.247241 170.628714,170.628714 C132.247241,209.010186 70.1869539,209.549474 31.1442786,171.840796 Z"
                fill="#E59733"
              ></path>
              <polygon
                fill="#ffffff"
                points="66.6666667 89.4527363 89.5522388 112.437811 132.338308 69.6517413 146.268657 83.7810945 89.5522388 140.298507 52.7363184 103.482587 66.6666667 89.3532338"
              ></polygon>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div
      class="flex md:block bg-white rounded-lg shadow border-blue-500 border-2 p-2 md:p-6 mb-4 md:mb-8 mx-auto items-center cursor-pointer hover:bg-blue-50 focus:outline-none"
      :class="{ 'bg-white border-blue-500 border-4': this.activeProduct === this.productName }"
      tabindex="0"
      @click="updateActiveProduct"
      @keydown.space="updateActiveProduct"
    >
      <div class="mx-2 md:mx-0 my-2">
        <slot></slot>
      </div>
      <div class="text-center">
        <span class="text-base font-semibold text-blue-500">{{ this.productName }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Model, Vue } from "vue-property-decorator";

@Component
export default class ProductListItem extends Vue {
  @Prop({ type: String, default: "", required: true }) productName!: string;
  @Model("on-product-selected", { type: String }) readonly activeProduct!: string;

  updateActiveProduct(): void {
    this.$emit("on-product-selected", this.productName);
  }
}
</script>

<style lang="scss">
.border-blue-500 {
  border-color: #004593 !important;
}
.text-blue-500 {
  color: #004593 !important;
}
</style>
